export interface Elevation {
  sm: string;
  md: string;
  lg: string;
  xl: string;
  "2xl": string;
}

export const elevation: Elevation = {
  sm: "0px 2px 4px 0px rgba(0, 0, 0, 0.08)",
  md: "0px 4px 8px 0px rgba(0, 0, 0, 0.15)",
  lg: "0px 4px 10px 0px rgba(0, 0, 0, 0.15)",
  xl: "0px 4px 16px 0px rgba(0, 0, 0, 0.15)",
  "2xl": "0px 8px 16px 0px rgba(0, 0, 0, 0.15)",
};
